export const CARD_TYPE = {
  card: 0,
  cashapp: 1,
  prepaid:2
};
